import type { FC } from "react";

import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";
import { Flex, Typography, useUiKitComponents } from "~/shared/ui-kit";

import type { FooterV3Props } from "../FooterV3";

export const FooterMenu: FC<FooterV3Props> = ({
  getUrl,
  onCallAction,
  data,
  isControlInactive,
}) => {
  const { Link } = useUiKitComponents();
  return (
    <Flex
      justify="center"
      flexDirection="column"
      align="center"
      className="mx-auto mt-10"
      gap={16}
      as="ul"
    >
      {data?.menu?.action_items?.map((item) => {
        const controlAction = item?.menu_action_items_id?.action;
        const action = controlAction?.action?.[0];
        const isInactive = controlAction
          ? isControlInactive(controlAction)
          : true;

        let href;
        if (isExternalLink(action?.item)) {
          href = action.item.href ?? undefined;
        }
        if (isInternalLink(action?.item)) {
          href = action.item.page ? getUrl(action.item.page) : undefined;
        }
        const handlePressLink = (): void => {
          if (action) {
            onCallAction(action);
          }
        };
        return (
          !isInactive && (
            <Typography
              as="li"
              size="medium"
              className="text-[#C7C7CB]"
              key={item?.id}
            >
              <Link href={href} onClick={handlePressLink}>
                {item?.menu_action_items_id?.action?.name}
              </Link>
            </Typography>
          )
        );
      })}
    </Flex>
  );
};
